interface Customer {
  id: string
  firstName: string
  lastName: string
  email: string
}

export function useAuth() {
  const customer = useState<Customer | null>('auth:customer', () => null)
  const isLoggedIn = computed(() => customer.value !== null)

  async function fetchMe() {
    try {
      const data = await $fetch<{ customer: Customer | null }>('/api/auth/me')
      customer.value = data.customer
    }
    catch {
      customer.value = null
    }
  }

  async function login(email: string, password: string) {
    const data = await $fetch<{ success: boolean; customer: Customer }>('/api/auth/login', {
      method: 'POST',
      body: { email, password },
    })
    customer.value = data.customer
  }

  async function register(firstName: string, lastName: string, email: string, password: string) {
    await $fetch('/api/auth/register', {
      method: 'POST',
      body: { firstName, lastName, email, password },
    })
  }

  async function logout() {
    await $fetch('/api/auth/logout', { method: 'POST' })
    customer.value = null
  }

  return { customer, isLoggedIn, fetchMe, login, register, logout }
}
